import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBm4icmQw1N4fj5smdlzXfVIoX4ty7MZGQ",
  authDomain: "lifeplus-2025.firebaseapp.com",
  projectId: "lifeplus-2025",
  storageBucket: "lifeplus-2025.firebasestorage.app",
  messagingSenderId: "504961950220",
  appId: "1:504961950220:web:0feeac0f452f4d03820429",
  measurementId: "G-L92N5ZRJQ9"
};

export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export default { analytics };